import { render, staticRenderFns } from "./LayoutTwo.vue?vue&type=template&id=4ee6c553"
import script from "./LayoutTwo.vue?vue&type=script&lang=js"
export * from "./LayoutTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports